import { Driver, Roadmap, Vehicle, DeliveryRoadmap } from "./types"

export enum ActionType {
    UPDATE_DRIVERS = 'updateDrivers',
    REMOVE_DRIVERS = 'removeDrivers',
    UPDATE_VEHICLES = 'updateVehicles',
    REMOVE_VEHICLES = 'removeVehicles',
    UPDATE_ROADMAPS = 'updateRoadmaps',
    REMOVE_ROADMAPS = 'removeRoadmaps',
    UPDATE_DELIVERY_ROADMAPS = 'updateDeliveryRoadmaps',
    REMOVE_DELIVERY_ROADMAPS = 'removeDeliveryRoadmaps'
}

interface UpdateDrivers {
    type: ActionType.UPDATE_DRIVERS
    payload: Driver[]
}

interface RemoveDrivers {
    type: ActionType.REMOVE_DRIVERS
    payload: string[]
}

interface UpdateVehicles {
    type: ActionType.UPDATE_VEHICLES
    payload: Vehicle[]
}

interface RemoveVehicles {
    type: ActionType.REMOVE_VEHICLES
    payload: string[]
}

interface UpdateRoadmaps {
    type: ActionType.UPDATE_ROADMAPS
    payload: Roadmap[]
}

interface RemoveRoadmaps {
    type: ActionType.REMOVE_ROADMAPS
    payload: string[]
}

interface UpdateDeliveryRoadmaps {
    type: ActionType.UPDATE_DELIVERY_ROADMAPS
    payload: DeliveryRoadmap[]
}

interface RemoveDeliveryRoadmaps {
    type: ActionType.REMOVE_DELIVERY_ROADMAPS
    payload: string[]
}

export type LogisticsAction =
    LogisticsUpdateAction |
    LogisticsRemoveAction

export type LogisticsUpdateAction =
    UpdateDrivers |
    UpdateVehicles |
    UpdateRoadmaps |
    UpdateDeliveryRoadmaps

export type LogisticsRemoveAction =
    RemoveDrivers |
    RemoveVehicles |
    RemoveRoadmaps |
    RemoveDeliveryRoadmaps
